import superagent from '@ott/superagent';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiEndpoint } from '../../constants';
import prepareQuery from '../../helpers/prepareQuery';
import { RequestError } from '../../types';
import { RequestResponse, Payload } from './types';

export const releaseCard = createAsyncThunk<
  RequestResponse,
  Payload,
  { rejectValue: RequestError }
>('virtualCard/releaseCard/fetch', async (payload, { dispatch, rejectWithValue }) => {
  try {
    const url = ApiEndpoint.CardOpen;

    const { phone, pin = '' } = payload;
    const params = prepareQuery();
    const data: Payload = {
      phone: phone.replace('+', ''),
    };

    if (pin) {
      data.pin = pin;
    }

    const {
      body: { error, result },
    } = await superagent.post(url).query(params).send(data);

    if (error) {
      throw error;
    }

    return result as RequestResponse;
  } catch (error: any) {
    return rejectWithValue(error.response.body as RequestError);
  }
});
